import { useMutation } from 'react-query'
import { UseMutationOptions } from 'react-query/types/react/types'
import { useCreateSchedule, Data, Variables } from 'hooks/queries/brandKits/useCreateSchedule'

interface Props {
  brandPlanId: number
}

export interface Options extends Omit<UseMutationOptions<Data[], Error, Variables[]>, 'mutationFn'> {}

export const useCreateSchedules = ({ brandPlanId }: Props, options?: Options) => {
  const { mutateAsync: createSchedule } = useCreateSchedule({ brandPlanId })

  return useMutation<Data[], Error, Variables[]>(
    (variables) => {
      return Promise.all(variables.map(variables => {
        return createSchedule(variables)
      }))
    },
    options,
  )
}
